import { ReactNode } from 'react';
import { UnauthenticatedHeader } from 'shared/components/main-components/unauthenticated-header';

export const UnauthenticatedLayout = ({ children }: { children: ReactNode }) => (
  <div className="main-layout">
    <UnauthenticatedHeader />
    {children}
  </div>
);
